import React from "react";
import styled from "styled-components";
import { CompanyLogo } from "../../components/tables/CompanyLogo";
import {
  ElementContainer,
  FlexibleContainer,
  VerticalLine,
} from "../../components/containers/styledComponents";
import {
  Pathway,
  PathwayBox,
} from "../../components/visuals/PathwayProgressBar";
import { FlagBox } from "../../components/visuals/FlagBox";
import { NewsStatusSegment } from "../../components/common/NewsTimelineCard/NewsStatusSegment";
import { CompanySummary } from "../../models/CompanyprofileModels";
import { lightGreys } from "../../styles";
import { formatReadable } from "../../utils/formattingUtils";

type CompanyStatusHeaderProps = {
  companyName: string;
  pathway: Pathway;
  data: CompanySummary | null;
  isLoading?: boolean;
  companyId?: string;
  showNews?: boolean;
};

const CompanyStatusHeaderContainer = styled(ElementContainer)`
  padding: 14px;
  border-radius: 8px;
  background-color: white;
  box-shadow: 0px 2px 2px rgba(0, 0, 0, 0.04);
`;

export const CompanyStatusHeader = ({
  companyId,
  companyName,
  pathway,
  data,
  isLoading = false,
  showNews = false,
}: CompanyStatusHeaderProps): JSX.Element => {
  const formattedCompanyName = formatReadable(companyName);

  return (
    <CompanyStatusHeaderContainer ai="center">
      <FlexibleContainer ml={"14px"}>
        <CompanyLogo
          key={formattedCompanyName}
          {...(companyId && { companyId })}
          name={formattedCompanyName}
          logoUrl={data?.image || ""}
          isLoading={isLoading}
          size="lg"
        />
      </FlexibleContainer>
      <VerticalLine color={lightGreys.borderLightGrey} />
      <PathwayBox pathwayItem={pathway} isLoading={isLoading} />
      <VerticalLine color={lightGreys.borderLightGrey} />
      <FlagBox flagKey={data?.flag_status || null} isLoading={isLoading} />
      {showNews && companyId && (
        <>
          <VerticalLine color={lightGreys.borderLightGrey} />
          <NewsStatusSegment key={companyId} companyId={companyId} />
        </>
      )}
    </CompanyStatusHeaderContainer>
  );
};
